import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import BrandLogo from "@/components/BrandLogo";
import { toast } from "sonner";

export default function PortalAccess() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.post(`${API}/public/my-portal/consume`, { token });
        sessionStorage.setItem("portal_token", data.session_token);
        sessionStorage.setItem("portal_email", data.email);
        setStatus("ok");
        navigate("/my-portal/home", { replace: true });
      } catch (err) {
        setStatus("error");
        toast.error(err.response?.data?.detail || "Link is invalid or expired");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="marketing hero-bg flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-3 text-muted-foreground" data-testid="portal-access-status">
        <BrandLogo size="md" />
        {status === "loading" && <p>Opening your portal…</p>}
        {status === "error" && (
          <div className="text-center">
            <p className="mb-3">This link isn't valid or has expired.</p>
            <a href="/client-login" className="text-primary hover:underline" data-testid="portal-request-new-link">Request a new link →</a>
          </div>
        )}
      </div>
    </div>
  );
}
